import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.logs = [
      "{\"status\": \"200\", \"msg\": \"Syncing core_assets...\"}",
      "{\"node\": \"MP-01\", \"load\": \"0.42\", \"temp\": \"38C\"}",
      "{\"event\": \"AUTH_SUCCESS\", \"user\": \"root\", \"ip\": \"10.0.0.1\"}",
      "{\"process\": \"worker_7\", \"action\": \"cleanup\", \"result\": \"DONE\"}",
      "{\"db_sync\": \"COMPLETE\", \"latency\": \"0.8ms\", \"shards\": \"12\"}",
      "{\"security\": \"WAF_ACTIVE\", \"threats\": \"0\", \"mode\": \"STRICT\"}",
      "{\"traffic\": \"14.2k req/s\", \"error_rate\": \"0.00%\"}",
      "{\"build\": \"#7721\", \"status\": \"DEPLOYED\", \"env\": \"PROD\"}",
      "{\"cache\": \"HIT\", \"key\": \"user_session_f8d2\", \"ttl\": \"3600\"}",
      "{\"logistics\": \"ROUTE_OPTIMIZED\", \"vehicles\": \"124\"}"
    ]
    
    this.startStreaming()
  }

  startStreaming() {
    this.interval = setInterval(() => {
      this.addLog()
    }, 800)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  addLog() {
    const log = this.logs[Math.floor(Math.random() * this.logs.length)]
    const line = document.createElement("p")
    line.className = "font-mono text-[10px] mb-1 opacity-0 transition-opacity duration-500 whitespace-nowrap"
    
    // Simple syntax highlighting for JSON-like logs
    const highlighted = log
      .replace(/"(\w+)":/g, '<span class="text-primary/60">"$1"</span>:')
      .replace(/: "([^"]+)"/g, ': <span class="text-surface-variant/80">"$1"</span>')
      .replace(/: (\d+\.?\d*)/g, ': <span class="text-amber-400/60">$1</span>')

    line.innerHTML = highlighted
    
    this.containerTarget.appendChild(line)
    
    // Animate in
    requestAnimationFrame(() => {
      line.classList.remove("opacity-0")
    })

    // Scroll to bottom
    this.containerTarget.scrollTop = this.containerTarget.scrollHeight

    // Remove old logs
    if (this.containerTarget.children.length > 20) {
      this.containerTarget.removeChild(this.containerTarget.firstChild)
    }
  }
}
